const LEGACY_WORD_SIGNATURE = [
  0xd0, 0xcf, 0x11, 0xe0,
  0xa1, 0xb1, 0x1a, 0xe1,
];

export const isLegacyWordDocument = async (file) => {
  const uploadFile = file?.file || file;
  if (uploadFile?.type === "application/msword") return true;
  if (!uploadFile?.slice) return false;

  const bytes = new Uint8Array(await uploadFile.slice(0, 8).arrayBuffer());
  return LEGACY_WORD_SIGNATURE.every((byte, index) => bytes[index] === byte);
};

export const hasLegacyWordDocument = async (files = []) => {
  for (const file of files) {
    if (await isLegacyWordDocument(file)) return true;
  }
  return false;
};
